import { styled, Card } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

export const StyledCard = styled(Card)({
  border: '1px solid',
  borderColor: colors.grey[300],
  borderRadius: '4px',
  padding: '8px 16px 8px 12px',
  cursor: 'pointer',
  gap: '4px',
  boxShadow: 'none',
});
